import { type RecipeTypeRow } from "@/hooks/useGetRecipeTypes";
import { type UseFormReturn } from "react-hook-form";
import { RecipeTypeFilter } from "./RecipeTypeFilter";
import type { RecipesFilterFormValues } from "../RecipesFilterContainer";
import { FavoritesFilter } from "./FavoritesFilter";
import { HasMadeItFilter } from "./HasMadeItFilter";
import type { RecipeCategory } from "@/hooks/useGetRecipeCategories";
import { RecipeCategoryFilter } from "./RecipeCategoryFilter";
import { FilterFieldShell } from "./FilterFieldShell";
import { RecipeTypeChip } from "@/components/chips";

interface FiltersProps {
    form: UseFormReturn<RecipesFilterFormValues>;
    recipeTypes: RecipeTypeRow[];
    recipeCategories: RecipeCategory[];
    fixedType?: string;
    onApply(): void;
}

export const Filters = ({ form, recipeTypes, recipeCategories, fixedType, onApply }: FiltersProps) => {
    return (
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-4">
            {fixedType ? (
                <FilterFieldShell label="Type">
                    <div className="flex justify-center items-center h-9">
                        <RecipeTypeChip name={fixedType} />
                    </div>
                </FilterFieldShell>
            ) : (
                <RecipeTypeFilter control={form.control} recipeTypes={recipeTypes} onApply={onApply} />
            )}
            <RecipeCategoryFilter control={form.control} recipeCategories={recipeCategories} onApply={onApply} />
            <HasMadeItFilter control={form.control} onApply={onApply} />
            <FavoritesFilter control={form.control} onApply={onApply} />
        </div>
    );
};
